import BillingsCargoTaxiBulkUpdateStatusRequest, {
  BillingsCargoTaxiBulkUpdateStatusQueryParams,
  BillingsCargoTaxiBulkUpdateStatusRequestBody,
} from "./billings-cargo-taxi-bulk-update-status.request";

const createQueryParams = (
  params: BillingsCargoTaxiBulkUpdateStatusRequest,
): BillingsCargoTaxiBulkUpdateStatusQueryParams => {
  return {
    billingIds: params.billingIds,
  };
};

const createBody = (
  request: BillingsCargoTaxiBulkUpdateStatusRequest,
): BillingsCargoTaxiBulkUpdateStatusRequestBody => {
  return {
    status: request.status,
    comment: request.comment,
  };
};

const billingsCargoTaxiBulkUpdateStatusRequestFactory = {
  createBody,
  createQueryParams,
};

export default billingsCargoTaxiBulkUpdateStatusRequestFactory;
